"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProviders = fetchProviders;
exports.invalidateToken = invalidateToken;
exports.fetchMe = fetchMe;
exports.logIn = logIn;
exports.nerscLogIn = nerscLogIn;
exports.authenticateWithNewt = authenticateWithNewt;
exports.fetchTokenFromApiKey = fetchTokenFromApiKey;

var _lodashEs = require("lodash-es");

var _girderClient = _interopRequireDefault(require("@openchemistry/girder-client"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function fetchProviders(redirect) {
  return (0, _girderClient.default)().get('oauth/provider', {
    params: {
      redirect: redirect
    }
  }).then(function (response) {
    return response.data;
  });
}

function invalidateToken() {
  return (0, _girderClient.default)().delete("token/session").then(function (response) {
    return response.data;
  });
}

function fetchMe(token) {
  var config = {};

  if (!(0, _lodashEs.isNil)(token)) {
    config.headers = {
      'Girder-Token': token
    };
  }

  return (0, _girderClient.default)().get('user/me', config).then(function (response) {
    return response.data;
  });
}

function logIn(username, password) {
  var config = {};
  var authStr = btoa("".concat(username, ":").concat(password));
  config.headers = {
    'Girder-Authorization': "Basic ".concat(authStr)
  };
  return (0, _girderClient.default)().get('user/authentication', config).then(function (response) {
    return response.data;
  });
}

function nerscLogIn(username, password) {
  var mfa = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var data = new FormData();
  data.set('username', username);
  data.set('password', password + mfa);
  return _axios.default.post('https://newt.nersc.gov/newt/auth/', data).then(function (response) {
    return response.data;
  });
}

function authenticateWithNewt(sessionId) {
  return (0, _girderClient.default)().put("newt/authenticate/".concat(sessionId)).then(function (response) {
    return response.data;
  });
}

function fetchTokenFromApiKey(key) {
  return (0, _girderClient.default)().post('api_key/token', {}, {
    params: {
      key: key
    }
  }).then(function (response) {
    return response.data;
  });
}